var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGeoLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 14.6996L10.8498 10.8498C12.976 8.72362 12.976 5.27638 10.8498 3.15019C8.72362 1.02401 5.27638 1.02401 3.15019 3.15019C1.02401 5.27638 1.02401 8.72362 3.15019 10.8498L6.99999 14.6996ZM6.99999 16.8995L2.05025 11.9498C-0.683417 9.21603 -0.683417 4.78392 2.05025 2.05025C4.78392 -0.683417 9.21603 -0.683417 11.9498 2.05025C14.6834 4.78392 14.6834 9.21603 11.9498 11.9498L6.99999 16.8995ZM6.99999 8.55554C7.85912 8.55554 8.55554 7.85912 8.55554 6.99999C8.55554 6.14088 7.85912 5.44444 6.99999 5.44444C6.14086 5.44444 5.44444 6.14088 5.44444 6.99999C5.44444 7.85912 6.14086 8.55554 6.99999 8.55554ZM6.99999 10.1111C5.28177 10.1111 3.88888 8.71818 3.88888 6.99999C3.88888 5.28177 5.28177 3.88888 6.99999 3.88888C8.71818 3.88888 10.1111 5.28177 10.1111 6.99999C10.1111 8.71818 8.71818 10.1111 6.99999 10.1111Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGeoLocation);
export default __webpack_public_path__ + "static/media/userGeoLocation.db92a5d6f8d4751b9b63baff58c531a8.svg";
export { ForwardRef as ReactComponent };